import Axios from "axios";
import { createApp } from "vue";
import Localizer from "@Scripts/Common/Localizer";
import AppConfig from "@Scripts/Config/AppConfig";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import ResponsiveHelper from "@Scripts/Infrastructure/ResponsiveHelper";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Account", "Cart", "Catalogue", "Checkout", "Coupon", "Seo", "CookieToast"]
        });

        this.initRequestVerificationToken();

        const app = createApp({});
        (<any>app).config.devtools = false;

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            app.use(DataWeb.default);
            app.use(DataWebConfig);

            DataWeb.default.registerRoutes(router);
            DataWeb.default.registerStoreModules(store);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        app.use(router).use(store).use(AppConfig);

        (<any>window).App.instances.vm = app.mount('#app');

        const response = await store.dispatch("cartStore/getCartInfo");
        store.commit("cartStore/setCart", response.data);

        this.onLoad();
        this.setFancy();
        this.setTabs();
        this.setHideHeader();
        this.setExpanding();
        this.setExpandingLang();
        this.setAnalytics();
        this.setWrapMenu();
        this.setSocialShare();
        this.setInfoToast();
        this.setCloseInfoToast();

        ResponsiveHelper.onResize();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static onLoad() {
        $("*[data-preload]").removeAttr("data-preload");
    }

    private static setFancy() {
        (<any>window).$("[data-fancybox]").fancybox({
            buttons: [
                "zoom",
                "close"
            ],
            iframe: {
                scrolling: "auto"
            }
        });

        (<any>window).$(".close-fancy").click(function () {
            (<any>parent).$.fancybox.close(true);
        });
    }

    private static setTabs() {
        var $item = (<any>window).$(".item[data-exp=\"true\"]");
        (<any>window).$(".button", $item).bind("click", function () {
            var $itemCurrent = (<any>window).$(this).parent();

            (<any>window).$(".button", $item).not((<any>window).$(".button", $itemCurrent)).removeClass("active");
            (<any>window).$(".exp", $item).not((<any>window).$(".exp", $itemCurrent)).addClass("show");
            (<any>window).$(".button", $itemCurrent).toggleClass("active");
            (<any>window).$(".exp", $itemCurrent).toggleClass("show");
        });
    }

    private static setHideHeader() {
        var scrollDown = 0,
            header = ".app-header";

        (<any>window).$(window).scroll(function (event) {
            var up = (<any>window).$(this).scrollTop();
            if (up > scrollDown) {
                (<any>window).$(header).removeAttr("data-header-show");
            } else {
                (<any>window).$(header).attr("data-header-show", "true");
            }
            scrollDown = up;

            var scroll = (<any>window).$(window).scrollTop();
            if (scroll >= 150) {
                (<any>window).$(header).attr("data-header-hide", "true");
            } else {
                (<any>window).$(header).removeAttr("data-header-hide");
            }
        });

        (<any>window).$(window).scroll(function () {
            var scroll = (<any>window).$(window).scrollTop();
            if (scroll >= 100) {
                (<any>window).$(header).removeAttr("data-header-top");
            } else {
                (<any>window).$(header).attr("data-header-top", "true");
            }
        });
    }

    private static setExpanding() {
        (<any>window).$(".dropdown-toggle").click(function () {
            (<any>window).$(".dropdown-menu").toggle().toggleClass("show");
        });

        (<any>window).$(document).click(function (event) {
            if (!(<any>window).$(event.target).parents().hasClass("button-dropdown")) {
                (<any>window).$(".dropdown-menu").hide().removeClass("show");
            }
        });
    }

    private static setExpandingLang() {
        (<any>window).$(".dropdown-toggle-lang").click(function () {
            (<any>window).$(".dropdown-menu-lang").toggle().toggleClass("show");
        });

        (<any>window).$(document).click(function (event) {
            if (!(<any>window).$(event.target).parents().hasClass("button-dropdown-lang")) {
                (<any>window).$(".dropdown-menu-lang").hide().removeClass("show");
            }
        });
    }

    private static setAnalytics() {
        let dataGaeventLinkTrue = document.querySelectorAll(".ga-event");
        for (let i = 0; i < dataGaeventLinkTrue.length; i++) {
            dataGaeventLinkTrue[i].addEventListener("click", function (event) {
                if (dataGaeventLinkTrue[i].getAttribute("data-gacategory") == "homepage") {
                    GTagHelper.sendCustomEvent("click", { product_detail: dataGaeventLinkTrue[i].getAttribute("href") });
                }
                else {
                    GTagHelper.sendEvent(
                        dataGaeventLinkTrue[i].getAttribute("data-ganame") ? dataGaeventLinkTrue[i].getAttribute("data-ganame") : "click",
                        dataGaeventLinkTrue[i].getAttribute("data-gacategory"),
                        dataGaeventLinkTrue[i].getAttribute("data-galabel") === "link" ? dataGaeventLinkTrue[i].getAttribute("href") : dataGaeventLinkTrue[i].getAttribute("data-galabel"),
                    );
                }
            });
        }

        let gaEventEditorItems = document.querySelectorAll(".editor a");
        if (gaEventEditorItems && gaEventEditorItems.length != 0) {
            for (let i = 0; i < gaEventEditorItems.length; i++) {
                gaEventEditorItems[i].addEventListener("click", function () {
                    GTagHelper.sendEvent("click", "link", gaEventEditorItems[i].getAttribute("href"));
                });
            }
        }
    }

    public static setCarouselProducts() {
        var $products = (<any>window).$(".products");

        var btnNextArrow = "<div class=\"slick-arrow fastic-next\" data-type=\"next\"></div>",
            btnPrevArrow = "<div class=\"slick-arrow fastic-prev\" data-type=\"prev\"></div>",
            settings = {
                lazyLoad: "ondemand",
                infinite: true,
                speed: 900,
                centerPadding: "20px",
                slidesToShow: 4,
                slidesToScroll: 1,
                swipeToSlide: true,
                autoplay: true,
                autoplaySpeed: 4000,
                variableWidth: false,
                dots: false,
                nextArrow: btnNextArrow,
                prevArrow: btnPrevArrow,
                responsive: [
                    {
                        breakpoint: 1366,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1010,
                        settings: {
                            arrows: false,
                            centerMode: true,
                            centerPadding: "120px",
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 749,
                        settings: {
                            arrows: false,
                            centerMode: true,
                            centerPadding: "150px",
                            slidesToShow: 1,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 599,
                        settings: {
                            arrows: false,
                            centerMode: true,
                            centerPadding: "90px",
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            };

        (<any>window).$(".carousel.slick-initialized", $products).slick("removeSlide", null, false, true);
        (<any>window).$(".carousel.slick-initialized", $products).slick("unslick");
        (<any>window).$(".carousel", $products).not(".slick-initialized").slick(settings);
    }

    private static setWrapMenu() {
        (<any>window).$(".wrap-button[data-type=\"open\"]").bind("click", function () {
            (<any>window).$("body").attr("data-overflow", "hidden");
            (<any>window).$(".wrap-tap").attr("data-show", "true");
            (<any>window).$(".layer[data-color=\"azure\"]").attr("data-show", "true");
            setTimeout(function () {
                (<any>window).$(".layer[data-color=\"blue\"]").attr("data-show", "true");
            }, 50);
            setTimeout(function () {
                (<any>window).$(".menu, .top .list, .wrap-button[data-type=\"close\"]").attr("data-show", "true");
            }, 100);
        });

        (<any>window).$(".wrap-tap, .wrap-button[data-type=\"close\"]").click(function () {
            (<any>window).$(".menu, .top .list, .wrap-button[data-type=\"close\"]").removeAttr("data-show");
            setTimeout(function () {
                (<any>window).$(".layer[data-color=\"blue\"]").removeAttr("data-show");
            }, 50);
            setTimeout(function () {
                (<any>window).$("body").removeAttr("data-overflow");
                (<any>window).$(".wrap-tap-nav").removeAttr("data-show");
                (<any>window).$(".layer[data-color=\"azure\"]").removeAttr("data-show");
                (<any>window).$(".wrap-tap").removeAttr("data-show");
            }, 100);
        });
    }

    private static setSocialShare() {
        (<any>window).$(".share .share-wrap-button .icon[data-type='open']").unbind().bind("click", function () {
            (<any>window).$("body").attr("data-overflow", "hidden");
            (<any>window).$(".share .share-wrap-button").attr("data-show", "true");
            (<any>window).$(".share .list-item").attr("data-show", "true");

            var delay = 0;

            setTimeout(function () {
                (<any>window).$(".share .list-item .item").each(function () {
                    var $item = (<any>window).$(this);
                    setTimeout(function () {
                        $item.attr("data-show", "true");
                    }, delay += 100);
                });
            }, 100);
        });

        (<any>window).$(".share .share-wrap-button .icon[data-type='close']").unbind().bind("click", function () {
            var delay = 0;

            (<any>window).$(".share .list-item .item").each(function () {
                var $item = (<any>window).$(this);
                setTimeout(function () {
                    $item.removeAttr("data-show");
                }, delay += 50);
            });

            setTimeout(function () {
                (<any>window).$("body").removeAttr("data-overflow", "hidden");
                (<any>window).$(".share .share-wrap-button").removeAttr("data-show");
                (<any>window).$(".share .list-item").removeAttr("data-show");
            }, 300);
        });
    }

    private static setInfoToast() {
        let app = document.getElementById("body"),
            infoToast = document.getElementsByClassName("info-toast")[0];

        if (infoToast) {
            app.setAttribute('data-infotoast', '');
        }
    }

    private static setCloseInfoToast() {
        let app = document.getElementById("body"),
            closeInfoToast = document.getElementsByClassName("close-info-toast")[0],
            infoToast = document.getElementsByClassName("info-toast")[0];

        if (closeInfoToast) {
            closeInfoToast.addEventListener("click", function () {
                CookieHelper.setCookie("tst", "1", null);
                infoToast.classList.add("hden");
                app.removeAttribute('data-infotoast');
            });
        }
    }
}